import { render, staticRenderFns } from "./PagedDataTable.vue?vue&type=template&id=6e36ae59&"
import script from "./PagedDataTable.vue?vue&type=script&lang=ts&"
export * from "./PagedDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports